var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "page-content account",
      class: { "account--verify-route": _vm.routeNameIsVerify }
    },
    [
      _vm.isVerifyEmail
        ? _c("div", { staticClass: "mail verify ctsform" }, [
            _c("div", { staticClass: "mail-verify" }, [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("Account.JoinUs.VerificationByPin.Email")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "verify__inner" },
                [
                  _vm.isEmailVerified
                    ? _c("div", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("Account.VerificationByPin.Email.Verified")
                            ) +
                            "\n        "
                        )
                      ])
                    : _c("VerificationByPin", { attrs: { verify: "email" } })
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isVerifyPhone
        ? _c("div", { staticClass: "phone verify ctsform" }, [
            _c("div", { staticClass: "phone-verify" }, [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("Account.JoinUs.VerificationByPin.Phone")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "verify__inner" },
                [
                  _vm.isPhoneVerified
                    ? _c("div", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("Account.VerificationByPin.Phone.Verified")
                            ) +
                            "\n        "
                        )
                      ])
                    : _c("VerificationByPin", { attrs: { verify: "phone" } })
                ],
                1
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-514d6246", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-514d6246","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/IntegratedWallet/EmailAndPhoneVerification.vue
// module id = null
// module chunks = 